import styled from '@emotion/styled';
import { LoadingButton } from '@mui/lab';
import { DialogTitle } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import useUpdateCoddingManual from 'api/coddingManual/useUpdateCoddingManual/useUpdateCoddingManual';
import React, { useEffect, useState } from 'react';

import SpinnerLoader from '../../../SpinnerLoader/SpinnerLoader';
import TryAgain from '../../../TryAgain/TryAgain';

const ProductCoddingEditModal = ({
  open,
  handleClose,
  selectedGuid,
  onUpdate,
}) => {
  const [code, setCode] = useState('');
  const [title, setTitle] = useState('');
  const [titleRequired, setTitleRequired] = useState(false);

  const { loading, update, getData, data, error, setData } =
    useUpdateCoddingManual();

  useEffect(() => {
    if (open && selectedGuid) {
      getData(selectedGuid);
    } else {
      setCode('');
      setTitle('');
      setTitleRequired(false);
      setData(null);
    }
  }, [open, selectedGuid]);

  useEffect(() => {
    if (!data) return;

    setCode(data.code ?? '');
    setTitle(data.title ?? '');
    setTitleRequired(!!data.titleRequired);
  }, [data]);

  const submitCodeGroup = () => {
    if (!selectedGuid || !code) return;
    if (titleRequired && !title) return;

    update(
      {
        guid: selectedGuid,
        title: titleRequired ? title : title || code,
        code,
        titleRequired,
      },
      () => onUpdate?.(code),
    );
  };

  return (
    <Dialog open={open} onClose={handleClose} sx={{ direction: 'rtl' }}>
      <DialogTitle>ویرایش کدینگ</DialogTitle>

      <DialogContent>
        {error && !loading ? (
          <TryAgain tryAgain={() => getData(selectedGuid)} />
        ) : null}

        {loading && !data ? <SpinnerLoader /> : null}

        {!loading && !error && data ? (
          <>
            {titleRequired ? (
              <FilledWrapper>
                <FilledLabel>عنوان</FilledLabel>
                <TextField
                  autoFocus
                  variant="standard"
                  value={title}
                  onChange={e => setTitle(e.target.value)}
                  sx={{ minWidth: 300 }}
                  error={!title}
                />
              </FilledWrapper>
            ) : null}

            <FilledWrapper>
              <FilledLabel>کد</FilledLabel>
              <TextField
                autoFocus={!titleRequired}
                variant="standard"
                multiline
                value={code}
                onChange={e => setCode(e.target.value)}
                sx={{ minWidth: 300 }}
                error={!code}
              />
            </FilledWrapper>
          </>
        ) : null}
      </DialogContent>

      <DialogActions sx={{ gap: 1, padding: 3 }}>
        <Button onClick={handleClose} variant="contained" disabled={loading}>
          انصراف
        </Button>
        <LoadingButton
          variant="contained"
          color="warning"
          onClick={submitCodeGroup}
          loading={loading}
          disabled={!data || !code || (titleRequired && !title)}
        >
          ویرایش
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default ProductCoddingEditModal;

const FilledWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
  margin-top: 30px;
`;

const FilledLabel = styled.label``;
